import styled from 'styled-components';
import { mixins, styles } from '4all-ui/styles';
import { Container as GenericListHeaderContainer, Desc } from '../GenericListHeader/style';
import { customScrollbar } from '../../styles/mixins';
import { EmptyMessage } from '../VariationOptionForm/style';

export const TagsContainer = styled.div`
  height: 494px;

  ${GenericListHeaderContainer} {
    flex-direction: column;

    ${Desc} {
      max-width: 200px;
    }
  }
`;

export const Tags = styled.div`
  margin-right: -10px;
  margin-top: 40px;
  height: 328px;
  overflow: scroll;
  padding-right: 10px;
  position: relative;
  ${mixins.flexPosition({ align: 'flex-start', justify: 'center' })}
  flex-wrap: wrap;
  ${customScrollbar()}
`;

export const StyledEmptyMessage = styled(EmptyMessage)`
  max-width: 175px;
`;

export const ErrorMessage = styled.p`
  ${mixins.fontStyle(
    styles.colors.GRAY_MEDIUM_3,
    styles.fontSizes.SIZE_6,
    styles.fontWeights.NORMAL
  )}
  margin-top: 100px;
`;



// WEBPACK FOOTER //
// ./src/components/SelectTagList/style.js